<template>
<div class="d-flex justify-content-end mb-2">

	<div>
		<info-box v-if="selectedElement == 'labour'" class="mr-1"
			label="Total Labour Hours" 
			:value="totalLabourHours.toFixed(2)"
			:stacked="true"
			:standout="true">
		</info-box>
	</div>
	<div>
		<info-box v-if="selectedElement != 'additional-factors'"
			:label="'Total Cost ' + elementLabelMap[selectedElement]" 
			:value="'$ ' + totalElementCost.toCurrency()"
			:stacked="true"
			:standout="true"
			class="mr-1">
		</info-box>
	</div>

	<div class="d-flex justify-content-end mb-2">
		
		<info-box v-if="selectedElement == 'labour'" class="mr-1"
			label="Total Labour Hours" 
			:value="totalLabourHours.toFixed(2)"
			:stacked="true"
			:standout="true">
		</info-box>
		
		<info-box style="display: inline-block;"
			:label="'Total Value ' + elementLabelMap[selectedElement]" 
			:value="'$ ' + totalElementValue.toCurrency()"
			:title="showRoundingDisclaimer ? 'This value reflects component level-rounding and therefore slightly differs from the line-item totals.' : ''"
			class="mr-1"
			:stacked="true"
			:standout="true">
		</info-box>

		<info-box v-if="selectedElement != 'additional-factors'"
			label="Margin" 
			:value="totalElementMargin.toFixed(1) + '%'"
			:stacked="true"
			:standout="true">
		</info-box>
	</div>
</div>
</template>
<script>
import InfoBox from "@/components/InfoBox"

export default {
	name: "CompiledBidElementInfoBoxes",
	components: {
		InfoBox
	},
	props: [
		"selectedElement",
		"totalElementMargin",
		"totalElementCost",
		"totalElementValue",
		"elementLabelMap",
		"totalLabourHours"
	],
	computed: {
		showRoundingDisclaimer() {
			return Math.abs(this.totalElementValue - this.rawElementValue) > 0.01
		}
	}
}
</script>